import { MobileLayoutShell } from "@circle-react/components/Mobile/MobileLayoutShell";
import { useIsMobile } from "@circleco/compass/hooks/useIsMobile";

import { useShellRevealEffect } from "@/react/components/CircleAi/useShellReveal";

import { CanvasHeaderProvider } from "./CanvasHeader/CanvasHeaderContext";
import { CanvasMobilePageHeader } from "./CanvasHeader/CanvasMobilePageHeader";
import {
  CircleAIAppShellLayoutDesktop,
  type CircleAIAppShellLayoutProps,
} from "./DesktopLayout";

/**
 * Gate component: on mobile viewports,
 * skip the entire AI shell (dock, conversation panel, sidebar) and
 * render the Compass MobileShell directly. The AI shell is a desktop
 * experience; the mobile shell provides its own chrome.
 *
 * This is a separate component (not an early return inside the main
 * CircleAIAppShellLayout) to avoid violating React's rules of hooks.
 */
export const CircleAIAppShellLayout = ({
  children,
  ...props
}: CircleAIAppShellLayoutProps) => {
  const isMobile = useIsMobile();

  useShellRevealEffect();

  if (isMobile) {
    return (
      <CanvasHeaderProvider>
        <MobileLayoutShell>
          <CanvasMobilePageHeader />
          {children}
        </MobileLayoutShell>
      </CanvasHeaderProvider>
    );
  }

  return (
    <CircleAIAppShellLayoutDesktop {...props}>
      {children}
    </CircleAIAppShellLayoutDesktop>
  );
};
